:host {
  display: block;
}

.qumra-search-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
}
.qumra-flex{
  display: flex;
}
.qumra-hidden{
  display: none;
}
.qumra-fixed{
  position: fixed;
}
.qumra-search-input-container{
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px;
  background-color: var(--mainColor);
  border: 1px solid #FFFFFF;
  border-radius: var(--mainRadius);
  color: var(--mainColor);
}
/* xxs: "320px",
xs:"410px",
sm:"576px",
md:"768px",
lg:"992px",
xl:"1200px",
"2xl":"1400px", */
@media (min-width: 992px) {
  .qumra-search-input-container{
  width: 50%;
  }
}




.qumra-search-input {
  background-color: white;
  border: 1px solid #FFFFFF;
  outline: none;
  border-radius: var(--mainRadius);
  color: var(--mainColor);
  padding: 24px 20px;
  outline: none;
  width: 100%;
}
.qumra-close-button {
  position: absolute;
  top: 64px;
  right: 64px;
  cursor: pointer;
}